import { FieldInputProps, useField } from "formik";
import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { BasicInput } from "../BasicInput/BasicInput";
import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { FieldHeader, FieldHeaderProps, FieldStateProps } from "../FieldHeader";
import { ReadOnlyTextField } from "../ReadOnlyTextField/ReadOnlyTextField";
import { useSetFieldTouched } from "../useSetFieldTouched";

export type TextFieldProps = Readonly<{
  name: string;
  maxLength?: number;
  maxLengthsByFieldName?: Record<string, number>;
  type?: "number" | "string";
  isStringNumber?: boolean;
  onlyInternalElements?: boolean;
  renderDisabledAsInput?: boolean;
  placeholder?: string;
  // eslint-disable-next-line
  customOnBlur?: (e: React.ChangeEvent<HTMLInputElement>, field: FieldInputProps<any>) => void;
  // eslint-disable-next-line
  customOnChange?: (e: React.ChangeEvent<HTMLInputElement>, field: FieldInputProps<any>) => void;
  customOnKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const TextField = (props: TextFieldProps) => {
  const [field] = useField(props);
  useSetFieldTouched(field.name);

  const { maxLength, disabled, onlyInternalElements, maxLengthsByFieldName } = props;

  let forceMaxLengthByFieldName: undefined | number;
  if (maxLengthsByFieldName) {
    forceMaxLengthByFieldName = maxLengthsByFieldName[field.name];
  }

  const InternalTextField = (
    <>
      <FieldHeader {...props} htmlFor={field.name} titleClassName={commonStyles.textFieldLabel} />
      {disabled && !props.renderDisabledAsInput && <ReadOnlyTextField name={field.name} />}
      {(!disabled || props.renderDisabledAsInput) && (
        <BasicInput {...props} maxLength={maxLength ? maxLength : forceMaxLengthByFieldName} />
      )}
      <FieldErrorMessage fieldName={field.name} />
    </>
  );

  if (onlyInternalElements) {
    return InternalTextField;
  }

  return (
    <Row className={commonStyles.container}>
      <Column>{InternalTextField}</Column>
    </Row>
  );
};
